/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from "@mui/material";
import { NotifyStyled } from "./notify.styles";
import ShiftCard from "../../components/shift-card/shift-card";
import { useState, useEffect, useMemo } from "react";
import NotifyModal from "./notify-modal/notify-modal";
import {
  getAllNotifyAppointments,
  sendNotification,
} from "../../../../actions";
import { AxiosError } from "axios";
import { addNotification } from "../../../../store/slices/ui-slice";
import { v4 as uuid } from "uuid";
import { useAppDispatch } from "../../../../store/hooks";
import {
  formatDataUsingChicagoTime,
  isSomething,
} from "../../../../utils/common-utils";
import Loader from "../../../../components/loader/loader";
import { ProviderResponse } from "../../../../types/common-types";
import dayjs from "dayjs";
const now = dayjs();

const Notify = ({
  providersAppointmentData,
}: {
  providersAppointmentData: ProviderResponse[];
}) => {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState<any>(null);
  const [todayShifts, setTodayShifts] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  const findData = useMemo(
    () =>
      providersAppointmentData?.find(
        (x: any) => x?.display_name === "Dr. Brittany Marvel"
      ),
    []
  );

  const getShifts = () => {
    setLoading(true);
    getAllNotifyAppointments(findData?.actor_id)
      .then((response) => {
        const { data } = response.data;
        setTodayShifts(data.length > 0 ? data : null);
      })
      .catch((error: AxiosError) => {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: error.message,
          })
        );
        setTodayShifts(null);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!findData?.actor_id) {
      setLoading(false);
      return;
    }
    getShifts();
  }, []);

  const handleNotifyClick = async () => {
    setBtnLoading(true);
    try {
      const email = showModal?.email;
      const payload = { email };
      await sendNotification(payload);
      dispatch(
        addNotification({
          id: uuid(),
          type: "success",
          message: "Notification sent successfully!",
        })
      );
      setShowModal(null);
      getShifts();
    } catch (error: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message:
            error?.response?.data?.message || "Failed to notify customer.",
        })
      );
    } finally {
      setBtnLoading(false);
    }
  };

  const formattedTodayShifts = useMemo(() => {
    if (!todayShifts) return null;

    const filteredShifts = todayShifts
      .map((d: any) => formatDataUsingChicagoTime(d))
      .filter((x: any) => {
        const shiftDateTime = dayjs(x.start);
        return shiftDateTime.isSame(now, "day");
      });

    return filteredShifts.length > 0 ? filteredShifts : null;
  }, [todayShifts]);

  return (
    <NotifyStyled>
      <Box className="header">
        <Typography variant="h2">Notify Customer</Typography>
        <Typography variant="h5">{now.format("DD MMM YYYY")} Shifts</Typography>
      </Box>

      <Box className="content">
        {loading && <Loader absolute />}
        {!loading &&
          formattedTodayShifts &&
          formattedTodayShifts.length > 0 &&
          formattedTodayShifts.map((shift: any, index: number) => {
            const status = shift.notified ? "ongoing" : "onMyWay";
            return (
              <ShiftCard
                key={shift.id || index}
                name={shift?.name}
                time={shift?.time}
                address={shift?.address}
                petsCount={shift?.noOfPets}
                status={status}
                onMyWayHandler={() => setShowModal(shift)}
              />
            );
          })}

        {!loading &&
          (!formattedTodayShifts || formattedTodayShifts.length === 0) && (
            <Typography variant="body1" className="no-shifts">
              No shifts scheduled for today
            </Typography>
          )}
      </Box>

      {isSomething(showModal) && (
        <NotifyModal
          onClose={() => setShowModal(null)}
          data={showModal}
          btnProps={{
            onClick: handleNotifyClick,
            isLoading: btnLoading,
            disabled: btnLoading,
          }}
        />
      )}
    </NotifyStyled>
  );
};

export default Notify;
